export default __webpack_public_path__ + "static/media/greeting card icon 1.9f0fa0b4.svg";